import React, { useEffect, useState } from 'react';

// Preview for a local File. Creates one object URL per file and revokes it on unmount,
// instead of calling URL.createObjectURL on every render (leaks memory, heavy for GIFs).
const BlobImage = ({ file, ...props }) => {
    const [src, setSrc] = useState(null);

    useEffect(() => {
        const url = URL.createObjectURL(file);
        setSrc(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);

    if (!src) return null;
    return <img src={src} {...props} />;
};

export default BlobImage;
